import { TextWidget } from '@/components/widgets/text-widget/text-widget';
import { SubHeaderBold } from '@/ui/typography/widgets';
import { useTranslation } from 'react-i18next';
import SvgProjectFit from '@/assets/widgets/empty-state-project-fit.svg';

import { useProjectFit } from '../project-listing-sidebar/use-project-fit.query';
import { useUpdateProjectFit } from '../project-listing-sidebar/use-update-project-fit.mutation';
import { SkeletonWidget } from '../project-listing-sidebar/project-listing-sidebar';
import { styled } from 'goober';

export const ProjectFitWidget = ({
  projectListingId,
  hasEditPermission,
  widgetHeight,
  widgetWidth,
}: {
  projectListingId: string;
  hasEditPermission: boolean;
  widgetHeight?: number;
  widgetWidth: number;
}) => {
  const { t } = useTranslation('projects');
  const { data: projectFit, isLoading } = useProjectFit(projectListingId);
  const { updateProjectFit } = useUpdateProjectFit();

  if (isLoading) {
    return <SkeletonWidget width={widgetWidth} />;
  }

  const handleEdit = async (projectFitText: string | null) => {
    await updateProjectFit({
      projectListingId,
      projectFitText,
    });
  };

  return (
    <Widget
      dataTestId="project-fit-widget"
      height={widgetHeight}
      widgetWidth={widgetWidth}
      value={projectFit?.text ?? ''}
      header={<SubHeaderBold>{t`projectOverview.projectFit`}</SubHeaderBold>}
      placeholder={t`projectOverview.projectFitPlaceholder`}
      emptyStateOptions={{
        label: t`projectOverview.emptyState.labelProjectFit`,
        linkText: t`projectOverview.emptyState.linkTextProjectFit`,
        image: SvgProjectFit,
      }}
      onSave={handleEdit}
      disabled={!hasEditPermission}
    />
  );
};

const Widget = styled(TextWidget)<{ widgetWidth: number }>`
  max-width: ${({ widgetWidth }) => widgetWidth}px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    min-height: 180px;
  }

  @media (min-width: ${({ theme }) =>
      theme.breakpoints.md}px) and (max-width: ${({ theme }) =>
      theme.breakpoints.lg}px) {
    min-height: 220px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    min-height: 280px;
  }
`;
